var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletconnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.800049,
    y: 0.800049,
    width: 98.4,
    height: 98.4,
    rx: 49.2,
    fill: "#3B99FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2838 37.2568C41.1727 26.3678 58.8273 26.3678 69.7163 37.2568L71.0268 38.5673C71.5712 39.1118 71.5712 39.9945 71.0268 40.539L66.5438 45.0219C66.2716 45.2942 65.8302 45.2942 65.558 45.0219L63.7546 43.2185C56.1581 35.6221 43.8419 35.6221 36.2455 43.2185L34.3142 45.1498C34.0419 45.4221 33.6006 45.4221 33.3283 45.1498L28.8454 40.6669C28.3009 40.1224 28.3009 39.2397 28.8454 38.6952L30.2838 37.2568ZM78.9875 46.5281L82.9773 50.518C83.5218 51.0624 83.5218 51.9452 82.9774 52.4896L64.9868 70.4805C64.4423 71.0249 63.5596 71.0249 63.0152 70.4805C63.0152 70.4805 63.0152 70.4805 63.0152 70.4805L50.2465 57.7118C50.1104 57.5757 49.8898 57.5757 49.7536 57.7118C49.7536 57.7118 49.7536 57.7118 49.7536 57.7118L36.9853 70.4805C36.4409 71.0249 35.5581 71.0249 35.0137 70.4805C35.0137 70.4805 35.0137 70.4805 35.0137 70.4805L17.0226 52.4894C16.4781 51.9449 16.4781 51.0622 17.0226 50.5177L21.0125 46.5279C21.5569 45.9834 22.4396 45.9834 22.9841 46.5279L35.7529 59.2967C35.889 59.4328 36.1097 59.4328 36.2458 59.2967C36.2458 59.2967 36.2458 59.2967 36.2458 59.2967L49.014 46.5279C49.5584 45.9834 50.4411 45.9834 50.9856 46.5278C50.9856 46.5278 50.9856 46.5279 50.9856 46.5279L63.7544 59.2967C63.8905 59.4328 64.1112 59.4328 64.2473 59.2967L77.0159 46.5281C77.5603 45.9837 78.443 45.9837 78.9875 46.5281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnectIcon);
export default __webpack_public_path__ + "static/media/walletconnect-icon.8bfc53bfb80db80e15a99be5defb175f.svg";
export { ForwardRef as ReactComponent };